// ----------------------------------------------------------------------------
// Cutter
// ----------------------------------------------------------------------------

import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkCutter from '@kitware/vtk.js/Filters/Core/Cutter';
import vtkPlane from '@kitware/vtk.js/Common/DataModel/Plane';
import vtkProperty from '@kitware/vtk.js/Rendering/Core/Property';
import vtkHttpSceneLoader from '@kitware/vtk.js/IO/Core/HttpSceneLoader';
import sceneSwitcher from '../html/sceneSwitcher.html';

let renderer;
let renderWindow;
let vtkModel;
function checkChanged(mysceneindex, checked) {
    vtkModel.scene[mysceneindex].actor.setVisibility(checked);
    vtkModel.renderWindow.render();
    //alert(mycheck + ": " + checked);
}

class vxVtkSceneSwitcher {
    static init(myVtkModel) {
        vtkModel = myVtkModel
        //renderer = vtkModel.renderer;
        //renderWindow = vtkModel.renderWindow;

        // -----------------------------------------------------------
        // UI control handling
        // -----------------------------------------------------------
        const controller = document.createElement('div');
        controller.className = 'controlPanel';
        controller.innerHTML = sceneSwitcher;
        vtkModel.container.parentNode.insertBefore(controller, vtkModel.container);

        // const controller = vtkModel.container.createElement('div');
        // controller.innerHtml=
        // vtkModel.container.appendChild(controlPanel);

        //renderWindow.addController(controlPanel);
        const myUl = document.getElementById('vx-sc-switcher');
        let i = 0;
        vtkModel.scene.forEach(
            (myScene) => {
                //console.log(JSON.stringify(myScene));
                const myli = document.createElement('LI');
                const mylabel = document.createElement('LABEL');
                mylabel.className = 'checkcontainer';
                mylabel.textContent = myScene.name.replace('.vtk','');
                const mycheck = document.createElement('INPUT');
                mycheck.setAttribute("type", "checkbox");
                mycheck.setAttribute("checked", " checked");
                mycheck.value = i; //todo id
                mycheck.addEventListener('change', (e) => { checkChanged(mycheck.value, mycheck.checked); } );
                const myspan = document.createElement('SPAN');
                myspan.className = 'checkmark';
                mylabel.appendChild(mycheck);
                mylabel.appendChild(myspan);
                myli.appendChild(mylabel);
                myUl.appendChild(myli);
                i++;
            }
        );
    }

    //static updatePlaneFunction = () => {
    //    plane.setOrigin(state.originX, state.originY, state.originZ);
    //    plane.setNormal(state.normalX, state.normalY, state.normalZ);
    //    renderWindow.render();
    //};

    //static setSource(source) {
    //    cutter.setInputConnection(source.getOutputPort());
    //}
}

export default vxVtkSceneSwitcher;